export interface Location {
  (): HTMLAnchorElement
  set(newLocation: string): boolean
  track(callback: () => void, interval?: number): void
  stopTrack(): void
}

export function createLocationProvider(): Location {
  let location = window.document.location
  const href: HTMLAnchorElement = window.document.createElement('a')
  return (() => {
    let timer = 0
    const _f: any = () => {
      return location
    }

    _f.set = (newLocation: string) => {
      href.href = newLocation
      if (href.host === '') {
        href.href = href.href
      }
      location = href as any

      _f.stopTrack()
      return true
    }

    _f.track = (callback: () => void, interval: number = 100) => {
      if (!timer) {
        let prev = location.pathname + '?' + location.search
        timer = window.setInterval(() => {
          const current = location.pathname + '?' + location.search
          if (prev !== current) {
            prev = current
            callback()
          }
        }, interval)
      }
    }

    _f.stopTrack = () => {
      if (timer) {
        clearInterval(timer)
        timer = 0
      }
    }

    return _f
  })()
}
